package com.iptvplayer.shared.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.String

public class IptvSourceQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    type: String,
    url: String?,
    serverUrl: String?,
    username: String?,
    password: String?,
  ) -> T): Query<T> = Query(-395_455_575, arrayOf("IptvSourceEntity"), driver, "IptvSource.sq",
      "selectAll",
      "SELECT IptvSourceEntity.id, IptvSourceEntity.name, IptvSourceEntity.type, IptvSourceEntity.url, IptvSourceEntity.serverUrl, IptvSourceEntity.username, IptvSourceEntity.password FROM IptvSourceEntity") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)
    )
  }

  public fun selectAll(): Query<IptvSourceEntity> = selectAll { id, name, type, url, serverUrl,
      username, password ->
    IptvSourceEntity(
      id,
      name,
      type,
      url,
      serverUrl,
      username,
      password
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    name: String,
    type: String,
    url: String?,
    serverUrl: String?,
    username: String?,
    password: String?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)
    )
  }

  public fun selectById(id: String): Query<IptvSourceEntity> = selectById(id) { id_, name, type,
      url, serverUrl, username, password ->
    IptvSourceEntity(
      id_,
      name,
      type,
      url,
      serverUrl,
      username,
      password
    )
  }

  public fun insert(
    id: String,
    name: String,
    type: String,
    url: String?,
    serverUrl: String?,
    username: String?,
    password: String?,
  ) {
    driver.execute(-96_850_795, """
        |INSERT OR REPLACE INTO IptvSourceEntity(id, name, type, url, serverUrl, username, password)
        |VALUES (?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 7) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, type)
          bindString(3, url)
          bindString(4, serverUrl)
          bindString(5, username)
          bindString(6, password)
        }
    notifyQueries(-96_850_795) { emit ->
      emit("IptvSourceEntity")
    }
  }

  public fun deleteById(id: String) {
    driver.execute(-248_601_607, """DELETE FROM IptvSourceEntity WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(-248_601_607) { emit ->
      emit("IptvSourceEntity")
    }
  }

  public fun deleteAll() {
    driver.execute(961_810_586, """DELETE FROM IptvSourceEntity""", 0)
    notifyQueries(961_810_586) { emit ->
      emit("IptvSourceEntity")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("IptvSourceEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("IptvSourceEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(625_820_362,
        """SELECT IptvSourceEntity.id, IptvSourceEntity.name, IptvSourceEntity.type, IptvSourceEntity.url, IptvSourceEntity.serverUrl, IptvSourceEntity.username, IptvSourceEntity.password FROM IptvSourceEntity WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "IptvSource.sq:selectById"
  }
}
